const config = {
  development: {
    api: 'https://api.site.dev.aurocraft.com/v1/',
    host: 'https://aurocraft.com'
  },
  production: {
    // api: 'https://api.site.dev.aurocraft.com/v1/',
    api: 'https://api.aurocraft.com/v1/',
    host: `${window.location.origin.replace('cms.', '')}`
  },
  testing: {
    api: 'https://api.site.dev.aurocraft.com/v1/',
    host: 'https://aurocraft.com'
  }
};

export default config[process.env.NODE_ENV]



// WEBPACK FOOTER //
// ./src/config.js